$(document).ready(() => {
  if (!window.dataLayer) {
    window.dataLayer = [];
  }
  $('[data-t-action-impression]').observe(
    (evt) => {
      const el = evt[0].target;
      if (evt[0].isIntersecting) {
        const $el = $(el).closest('[data-t-action-impression]');

        const event = $el.data('t-event') || 'gaEvent';
        const eventAction = $el.data('t-action-impression') || '';
        const eventCategory = $el.data('t-category') || '';
        const eventLabel = $el.data('t-label') || '';

        window.dataLayer.push({
          event,
          eventAction,
          eventLabel,
          eventCategory,
          nonInteraction: true,
        });
      }
    },
    { threshold: 0.2 }
  );
});
